/**
 * The 400 body when a sales or purchase order confirm is refused (ConfirmRefusalViewModel in the
 * API). Switch on `code` and word the message here, in $localize - the API deliberately sends no
 * sentence, so nothing on this path is ever shown in English to a non-English user.
 */
export interface ConfirmRefusal {
  code: string;
  /** ZeroBomQuantity: the offending lines, as "sequence - product key". */
  lines?: string[];
  /** DoNotSell: the keys of the products flagged Do Not Sell. */
  products?: string[];
  /** AlreadyConfirmed: who confirmed it last, when known. */
  confirmedBy?: string;
  /** AlreadyConfirmed: when it was confirmed last, when known. */
  confirmedDate?: string;
  /** OnStop: whether this user may confirm anyway (M4 Yes/No) rather than being refused (M3). */
  canOverride?: boolean;
  /** CreditCheckFailed: the customer's balance, already formatted by the API. */
  balance?: string;
}

/** Must match ConfirmRefusalCodes in the API (TMSWeb.Common/Constants). */
export const ConfirmRefusalCodes = {
  orderTypeDoNotAllowConfirm: 'OrderTypeDoNotAllowConfirm',
  zeroBomQuantity: 'ZeroBomQuantity',
  alreadyConfirmed: 'AlreadyConfirmed',
  doNotSell: 'DoNotSell',
  onStop: 'OnStop',
  creditCheckFailed: 'CreditCheckFailed',
} as const;
